type CanvasRenderer = (buffer: number[]) => void;
type WindowWithCanvasRenderer = Window & {
    canvasRender?: CanvasRenderer;
};

export const withoutCanvasRendering = <T>(operation: () => T): T => {
    const canvasWindow = window as WindowWithCanvasRenderer;
    const renderer = canvasWindow.canvasRender;
    canvasWindow.canvasRender = () => {};

    try {
        return operation();
    } finally {
        if (renderer) {
            canvasWindow.canvasRender = renderer;
        } else {
            delete canvasWindow.canvasRender;
        }
    }
};
